import { Alert, AlertType } from './alerts.interface';

export interface ApiError {
  type: string;
  request_id?: string;
  info?: {
    kind?: string;
    field?: string;
  };
}

export const ALERT_500: Alert = {
  type: AlertType.Error,
  title: {
    message: 'Error',
    translate: false,
  },
  message: {
    message: 'alert.custom.internal_server_error',
    translate: true,
  },
};

export const ALERT_429: Alert = {
  type: AlertType.Error,
  title: {
    message: 'Error',
    translate: false,
  },
  message: {
    message: 'error.type.too_many_requests',
    translate: true,
  },
};

export const ALERT_403: Alert = {
  type: AlertType.Error,
  title: {
    message: 'Error',
    translate: false,
  },
  message: {
    message: 'error.type.login_again',
    translate: true,
  },
};

// Custom alerts

export const ALERT_UPDATE_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.update_success',
    translate: true,
  },
};

export const ALERT_INVITE_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.invite_sent',
    translate: true,
  },
};

export const ALERT_REQUEST_SENT: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.request_sent',
    translate: true,
  },
};

export const ALERT_CAMPAIGN_BUY_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.campaign_buy_success',
    translate: true,
  },
};

export const ALERT_POST_SAVED: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.post_saved',
    translate: true,
  },
  time: 2000,
};

export const ALERT_POST_UPDATED: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.post_updated',
    translate: true,
  },
  time: 2000,
};

export const ALERT_CUSTOM_POST_ADDED: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.custom_post_added',
    translate: true,
  },
  time: 2000,
};

export const ALERT_TIMESLOT_OPENING_HOURS: Alert = {
  type: AlertType.Error,
  title: {
    message: 'Error',
    translate: false,
  },
  message: {
    message: 'alert.custom.opening_hours_required_to_set_timeslot',
    translate: true,
  },
};

export const ALERT_MAX_CAMPAIGNS: Alert = {
  type: AlertType.Error,
  title: {
    message: 'Error',
    translate: false,
  },
  message: {
    message: 'alert.custom.max_campaigns_reached',
    translate: true,
  },
};

export const ALERT_PRODUCT_REQUEST_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.product_request_success',
    translate: true,
  },
};

export const ALERT_MARKETPLACE_ITEM_ADD_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.marketplace_item_add_success',
    translate: true,
  },
};

export const ALERT_MARKETPLACE_BID_ADD_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.bid_added',
    translate: true,
  },
};

export const ALERT_MARKETPLACE_ITEM_EDIT_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.marketplace_item_add_success',
    translate: true,
  },
};

export const ALERT_MARKETPLACE_BID_REMOVE_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.bid_removed',
    translate: true,
  },
};

export const ALERT_MESSAGE_SENT_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.message_sent',
    translate: true,
  },
};

export const ALERT_HIGHLIGHTED_WARNING: Alert = {
  type: AlertType.Warning,
  title: {
    message: 'Warning',
    translate: false,
  },
  message: {
    message: 'alert.custom.highlighted_warning',
    translate: true,
  },
};

export const ALERT_SUBSCRIPTION_INACTIVE_SHOP: Alert = {
  type: AlertType.Error,
  title: {
    message: 'Error',
    translate: false,
  },
  message: {
    message: 'alert.custom.subscription_inactive_shop',
    translate: true,
  },
};

export const ALERT_POST_INACTIVE_SHOP: Alert = {
  type: AlertType.Error,
  title: {
    message: 'Error',
    translate: false,
  },
  message: {
    message: 'alert.custom.post_inactive_shop',
    translate: true,
  },
};

export const ALERT_IMPORT_USERS_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.import_users_success',
    translate: true,
  },
};

export const ALERT_DELETE_USERS_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.delete_users_success',
    translate: true,
  },
};

export const ALERT_DELETE_USER_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.delete_user_success',
    translate: true,
  },
};

export const ALERT_EXPORT_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.export_success',
    translate: true,
  },
};

export const ALERT_SEND_INVITATIONS_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.send_invitations_success',
    translate: true,
  },
};

export const ALERT_REMOVE_USER_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.remove_user_success',
    translate: true,
  },
};

// SHOWS
export const ALERT_REMOVE_SHOW_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.remove_show_success',
    translate: true,
  },
};

export const ALERT_ADD_SHOW_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.add_show_success',
    translate: true,
  },
};

// LOOKS

export const ALERT_REMOVE_LOOK_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.remove_look_success',
    translate: true,
  },
};

export const ALERT_ADD_LOOK_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.add_look_success',
    translate: true,
  },
};

export const ALERT_REMOVE_LOOK_PRODUCT_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.remove_look_product_success',
    translate: true,
  },
};

export const ALERT_ADD_LOOK_PRODUCT_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.add_look_product_success',
    translate: true,
  },
};

export const IMPORT_PRODUCTS_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.import_products_success',
    translate: true,
  },
};

export const ALERT_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'Success',
    translate: false,
  },
};

export const ALERT_ERROR: Alert = {
  type: AlertType.Error,
  title: {
    message: 'Error',
    translate: false,
  },
  message: {
    message: 'Error',
    translate: false,
  },
};
